// extracted by mini-css-extract-plugin
export default {"not-found-page__row":"BTyHTvEtSVJJDv2eua7DH","not-found-page__title":"_2Pze0-6BsxVDuIi0n6XrhU"};